module.exports = __webpack_public_path__ + "img/step-3-s.36146a6b.png";